/* -----------------Child components--------------- */
import { FilterView } from "@memorang/ui/components/FilterView";

import { useExamContext } from "@features/exam/contexts/ExamContext";
/* -----------------Others--------------- */
import useExams from "@hooks/useExams";
import { getPremiumContext } from "@memorang/helpers/bundle";
import type { BundleDetails } from "@memorang/types";
import { useToast } from "@memorang/ui/components/Toast";
import { useRouter } from "expo-router";
import { useMemo, useState } from "react";
import SearchNoResult from "../../../../assets/no-search-results.svg";

import { handleNavigateBack } from "@helpers/common";
import type { SearchbarProps } from "react-native-paper";
import { getProductTitle } from "../helpers";

type Props = {
	handleClose?: () => void;
	searchBarProps?: Partial<SearchbarProps>;
	postExamContextSwitchCallback?: (newExamId: string) => void;
};

const getPurchasedProductsDescription = (
	purchasedProducts: BundleDetails[],
) => {
	return `Purchased: ${purchasedProducts
		.map((product) => {
			return getProductTitle(product.bundle.bundleType);
		})
		.join(", ")}`;
};
const ExamsFilterRouteView = ({
	handleClose,
	searchBarProps,
	postExamContextSwitchCallback,
}: Props) => {
	const { groupedExams, examsList: exams } = useExams();

	const { showToast } = useToast();

	const {
		currentExamContext: { examId, examName },
		handleSwitchExamContext,
	} = useExamContext();

	const [selectedItemId, setSelectedItemId] = useState<string>(examId ?? "");

	const router = useRouter();

	const currentCategoryExamSelected = groupedExams?.find((item) => {
		return item.data.find(({ exam }) => exam.id === examId);
	});
	const sectionData = [...(groupedExams || [])]
		.sort(({ title }) => {
			return title === currentCategoryExamSelected?.title ? -1 : 1;
		})
		.map((group) => ({
			title: group.title,
			data: group.data.map(({ exam }) => {
				const purchasedProducts = exam.bundles.filter((bundle) => {
					return getPremiumContext(bundle.metadata).hasAccess;
				});
				return {
					name: exam.name,
					id: exam.id,
					description:
						purchasedProducts.length > 0
							? getPurchasedProductsDescription(purchasedProducts)
							: "",
				};
			}),
		}));

	const handleAction = async (selectedItemId: string, dismiss?: boolean) => {
		if (dismiss) {
			handleClose?.();
			return;
		}
		const examDetails = exams.find(({ exam }) => exam.id === selectedItemId);
		const message = `Switched Exam from "${examName}" to "${examDetails?.exam.name}"`;
		showToast({ message, duration: 500 });
		handleClose?.();
		router.replace("/home");
		await handleSwitchExamContext(examDetails!);
		postExamContextSwitchCallback?.(selectedItemId);
	};

	const selectedItem = useMemo(() => {
		return exams.find(({ exam }) => exam.id === selectedItemId);
	}, [exams, selectedItemId]);

	const cta =
		selectedItemId !== examId
			? `Switch to ${selectedItem?.exam.name}`
			: "Select exam...";
	return (
		<FilterView
			sectionData={sectionData}
			handleAction={handleAction}
			initSelectedItemId={examId}
			actionCta={cta}
			onBack={() => handleNavigateBack("home")}
			selectedItemId={selectedItemId}
			setSelectedItemId={setSelectedItemId}
			searchBarProps={searchBarProps}
			emptySearchResultSvg={SearchNoResult}
			currentItemSelectedLabel="Current Exam"
		/>
	);
};

export default ExamsFilterRouteView;
